/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';
import type { PermissionResponse } from './PermissionResponse';
import {
    PermissionResponseFromJSON,
    PermissionResponseFromJSONTyped,
    PermissionResponseToJSON,
    PermissionResponseToJSONTyped,
} from './PermissionResponse';

/**
 * 
 * @export
 * @interface PermissionResponsePagedResult
 */
export interface PermissionResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof PermissionResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<PermissionResponse>}
     * @memberof PermissionResponsePagedResult
     */
    data: Array<PermissionResponse> | null;
}

/**
 * Check if a given object implements the PermissionResponsePagedResult interface.
 */
export function instanceOfPermissionResponsePagedResult(value: object): value is PermissionResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PermissionResponsePagedResultFromJSON(json: any): PermissionResponsePagedResult {
    return PermissionResponsePagedResultFromJSONTyped(json, false);
}

export function PermissionResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(PermissionResponseFromJSON)),
    };
}

export function PermissionResponsePagedResultToJSON(json: any): PermissionResponsePagedResult {
    return PermissionResponsePagedResultToJSONTyped(json, false);
}

export function PermissionResponsePagedResultToJSONTyped(value?: PermissionResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(PermissionResponseToJSON)),
    };
}

